import { actionTypes } from '../actions/data'

// WRITES
const data = (state = {}, action) => {
  switch (action.type) {
    case actionTypes.LOAD_PERSONAL_STRATEGIES:
      return {
        ...state,
        personalStrategies: action.value
      }
    case actionTypes.PERSONAL_STRATEGIES_ERROR:
      return {
        ...state,
        personalStrategiesError: action.value
      }
    case actionTypes.PERSONAL_STRATEGIES_LOADING:
      return {
        ...state,
        personalStrategiesLoading: action.value
      }
    case actionTypes.MODEL_STRATEGIES_ERROR:
      return {
        ...state,
        modelStrategiesError: action.value
      }
    case actionTypes.MODEL_STRATEGIES_LOADING:
      return {
        ...state,
        modelStrategiesLoading: action.value
      }

    case actionTypes.LOAD_MODEL_STRATEGIES:
      return Object.assign({}, state, {
        modelStrategies: action.value
      })

    case actionTypes.LOAD_BENCHMARKS:
      return Object.assign({}, state, {
        benchmarks: action.value.benchmarks
      })

    case actionTypes.DELETE_A_STRATEGY:
      return {
        ...state,
        personalStrategies: state.personalStrategies.filter(d => d.id !== action.value)
      }

    case actionTypes.SHOW_A_STRATEGY:
      const strategy = state.personalStrategies.filter(d => d.id === action.value)

      // If the new stategy exists then show that, otherwise keep it as is
      return {
        ...state,
        strategyIdToShow: strategy && strategy.length > 0 ? action.value : null
      }

    case actionTypes.SHOW_ALL_STRATEGIES:
      return {
        ...state,
        strategyIdToShow: null
      }

    case actionTypes.SHOW_STRATEGY_EDITOR:
      return Object.assign({}, state, {
        strategyToEdit: action.value,
        strategyEditorVisible: true
      })

    case actionTypes.CLOSE_STRATEGY_EDITOR:
      return Object.assign({}, state, {
        strategyToEdit: null,
        strategyEditorVisible: false
      })

    case actionTypes.UPDATE_STRATEGY:
      // Filter out the stategy that was updated
      const remainingStrategies = state.personalStrategies.filter(d => d.id !== action.value.id)

      // Update the array of all strategies
      const updatedStrategies = [action.value].concat(remainingStrategies)

      return {
        ...state,
        personalStrategies: updatedStrategies
      }

    case actionTypes.SAVING_NEW_STRATEGY_IN_PROGRESS:
      // Update the array of all strategies
      const newStrategy = {
        id: 'newStrategy',
        name: action.value.name
      }

      return {
        ...state,
        strategySaveInProgress: 'newStrategy', // Placeholder ID for new strategy
        personalStrategies: [newStrategy].concat(state.personalStrategies)
      }

    case actionTypes.SAVING_STRATEGY_IN_PROGRESS:
      return {
        ...state,
        strategySaveInProgress: action.value // ID of the Strategy being saved
      }

    case actionTypes.SAVING_STRATEGY_COMPLETE:
      return {
        ...state,
        strategySaveInProgress: null // ID of the Strategy being saved
      }

    case actionTypes.SAVE_NEW_STRATEGY:
      // Create new array of strategies, filtering out the temporary one that was
      // in place whilst updating
      const newStrategies = [action.value].concat(state.personalStrategies.filter(perStrat => perStrat.id !== 'newStrategy'))

      return {
        ...state,
        personalStrategies: newStrategies
      }

    case actionTypes.HANDLE_CHECKBOX:
      let selectedStrategy = action.value
      let selectedStrategyId = selectedStrategy.id
      let selectedStrategyName = selectedStrategy.latestAnalysis.name
      return {
        ...state,
        selectedStrategids: selectedStrategyId,
        selectedStrategiesNames: selectedStrategyName
      }
    default:
      return state
  }
}

export default data
